export function getTimeDateObjectFromString(rawDateString: string) {
  const nDate = new Date();

  if (rawDateString.match("T")) {
    const startsAtTime = rawDateString
      .split("T")[1]
      .replace("Z", "")
      .split(":");
    nDate.setHours(Number(startsAtTime[0]), Number(startsAtTime[1]));
  } else if (rawDateString.match(":")) {
    const startsAtTime = rawDateString.split(":");
    nDate.setHours(Number(startsAtTime[0]), Number(startsAtTime[1]));
  } else {
    nDate.setHours(12, 0);
  }

  return nDate;
}
